import React from 'react'

const ModelsLoader = () => {
  const skeletonItems = Array(20).fill(0)
  return (
    <div className="flex flex-wrap justify-center mt-5 gap-4 px-4 sm:px-0">
      {skeletonItems.map((_, index) => (
        <div key={`skeleton-${index}`} className="model-card w-[46%] relative md:!w-[25%] lg:!w-[18%]">
          <div className="h-auto w-full rounded-xl bg-white dark:bg-gray-800 shadow-lg border border-transparent hover:border-gray-200 dark:hover:border-gray-700">
            {/* Image section */}
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-t-xl">
              <div className="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-800 rounded-t-xl">
                {/* Shimmering effect */}
                <div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 dark:via-white/10 to-transparent animate-shimmer"
                  style={{ backgroundSize: '200% 100%', animation: 'shimmer 2s infinite' }}
                ></div>

                {/* Subtle floating shapes for a modern look */}
                <div className="absolute top-1/4 left-1/4 w-12 h-12 rounded-full bg-gradient-to-br from-purple-400/20 to-indigo-500/20 animate-float-slow"></div>
                <div className="absolute bottom-1/3 right-1/3 w-16 h-16 rounded-full bg-gradient-to-br from-indigo-400/20 to-purple-500/20 animate-float-medium"></div>
                <div className="absolute top-1/2 right-1/4 w-8 h-8 rounded-lg bg-gradient-to-br from-blue-400/20 to-indigo-500/20 animate-float-fast"></div>
              </div>

              {/* Stats badges placeholders */}
              <div className="absolute bottom-3 left-3 z-10 flex gap-2">
                <div className="flex items-center gap-1 px-2 py-1 rounded-full bg-black/40 backdrop-blur-md text-white text-xs border border-white/20">
                  <div className="h-3 w-3 rounded-full bg-white/50" />
                  <div className="h-3 w-8 bg-white/50 rounded" />
                </div>
                <div className="flex items-center gap-1 px-2 py-1 rounded-full bg-black/40 backdrop-blur-md text-white text-xs border border-white/20">
                  <div className="h-3 w-3 rounded-full bg-white/50" />
                  <div className="h-3 w-8 bg-white/50 rounded" />
                </div>
              </div>

              {/* Heart button placeholder */}
              <div className="absolute top-3 right-3 z-10">
                <div className="w-9 h-9 rounded-full bg-black/30 backdrop-blur-sm flex items-center justify-center border border-white/20">
                  <div className="h-4 w-4 rounded-full bg-white/50" />
                </div>
              </div>
            </div>

            {/* Content section */}
            <div className="p-4 flex flex-col flex-1">
              <div className="h-5 w-3/4 bg-gradient-to-r from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-600 rounded mb-3 animate-pulse"></div>
              <div className="h-3 w-full bg-gradient-to-r from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-600 rounded mb-2 animate-pulse"></div>
              <div className="h-3 w-5/6 bg-gradient-to-r from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-600 rounded mb-4 animate-pulse"></div>

              <div className="mt-auto flex justify-between items-center">
                <div className="h-4 w-16 bg-gradient-to-r from-purple-400/30 to-purple-500/30 dark:from-purple-500/30 dark:to-purple-600/30 rounded animate-pulse"></div>
                <div className="h-8 w-16 rounded-full bg-gradient-to-r from-purple-400/50 to-indigo-500/50 dark:from-purple-500/40 dark:to-indigo-600/40 animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ModelsLoader
